<template>
  <div class="content">

    <card :loading="loading">
      <questionnaire @onLoad="loading = false"></questionnaire>
    </card>

    <div style="margin-top: 25px">
      <el-button @click="nextStap" type="primary" name="nextStap">Следующий шаг</el-button>
    </div>
  </div>
</template>

<script>
import Questionnaire from "../../../modules/questionnaire/Questionnaire.vue";
import Card from "../../../components/elements/Card.vue";

export default {
  name: "session.questionnaire",
  data() {
    return {
      loading: true
    }
  },
  components: {Questionnaire, Card},
  methods: {
    nextStap() {
      this.$router.push({name: "session.device"});
    }
  },
};
</script>

<style scoped lang="scss">

.content {
  max-width: 80%;
}

</style>
